import React, { Component }          from "react";
import { FontAwesomeIcon }           from '@fortawesome/react-fontawesome'
import { Button, ButtonGroup, Carousel, Modal, Tabs, Tab, nav }             from "react-bootstrap";
import LoaderButton                  from "../../components/LoaderButton";
import { Colors }                    from "../../utils/Colors";
import getMeasureTitle               from "../../utils/Measure";
import { ExerciseFreeFormId }        from "../../utils/StaticIds";
import { createHTMLMarkup }          from "../../utils/HTML";
import { invokeGetProgramOverview,
         invokeClientSingleExerciseSetsReps }  from "../../utils/AwsInvoke";
import uniqueId                      from 'lodash/uniqueId';
import "../../css/modal/ModalProgramOverview.css";
//import "../../css/modal/ModalBasics.css";
var day_tabs     = [];
var active_tab   = true; // used to intialize the first Day link in the first week upon initial load
export default class ModalProgramOverview extends Component {

    constructor(props) {
        super(props);

        this.state = {
            showModalProgramOverview: false,
            isLoading: false,
            index: 0,
            direction: null
        };
    }

    componentDidMount() {
        this.setState({
            showModalProgramOverview: this.props.showModalProgramOverview,
            programId: this.props.modalProgramId,
            isLoading: false
            //alertFunction:    this.props.alertFunction,
        });
        var program_id = this.props.modalProgramId;


        var week_id = 0;
        var day_id  = 0;
        this.setModalProgramOverview(program_id, week_id, day_id);
    }

    componentWillUnmount () {
        active_tab   = true;
    }

    /*componentDidUpdate(nextProps, prevState){
        if(nextProps.showModalProgramOverview !== prevState.showModalProgramOverview){
            this.setState ({
                showModalProgramOverview: nextProps.showModalProgramOverview
            });
        }
    }*/

    handleCloseWin = (action) => {
        this.setState({
            isLoading: true,
        });

        this.props.onHide();
    }

    createMarkup(html) { return {__html: html}; };


    parseProgramData (program_data) {
        var results      = program_data.data;
        var program_name = results.program_name;

        ////////////////////////////////////
        /////////    WEEKS DATA    /////////
        var weeks_id_data = results.weeks_id_order;
        //var weeks_id_order_uid  = weeks_id_data[0].uid;
        //var weeks_id_order      = weeks_id_data[0].week;
        var weeks_length        = weeks_id_data.length;

        var week_number = [];
        var week_uids    = [];
        for(var key in weeks_id_data) {
            //console.log("uid: " + weeks_id_data[key].uid);
            //console.log("week: " + weeks_id_data[key].week);
            week_uids.push(weeks_id_data[key].uid);
            week_number.push(weeks_id_data[key].week);
        }

        ////////////////////////////////////
        /////////    days DATA    /////////
        //console.log("++++++  DAYS  +++++");
        var days_id_data = results.days_id_order;
        //var days_id_order_uid  = days_id_data[0].uid;
        //var days_id_order      = days_id_data[0].day;
        var days_length        = days_id_data.length;
        var day_numbers = [];
        var day_uids    = [];

        for(var key in days_id_data) {
            day_uids.push(days_id_data[key].uid);
            day_numbers.push(days_id_data[key].day);
        }

        var current_week_id = this.state.currWeekId;
        var current_day_id  = this.state.currDayId;
        var tmp_day_id      = current_day_id;
        var tmp_week_id     = current_week_id;

        // If no day id is specified, use the first day of the week //
        if(current_week_id == undefined) tmp_week_id = week_uids[0]

        // If no day id is specified, use the first day of the week //
        if(current_day_id == 0) tmp_day_id = day_uids[0]

        this.setState({
            error_msg: "",
            programName: program_name,
            weeksLength: weeks_length,
            currWeekId:  tmp_week_id,
            weekUids:     week_uids,
            weekNumbers:  week_number,
            daysLength:  days_length,
            currDayId:   tmp_day_id,
            dayUids:     day_uids,
            dayNumbers:  day_numbers,
            dayData:     results.programBlockData

        })
    }

    setModalProgramOverview = async (program_id, week_id, day_id) => {
        var results = await invokeGetProgramOverview(program_id, week_id, day_id);

        this.parseProgramData(results)
    }

    parseExerciseDetailData (e_data, exerc_id) {

         var exer_arr = [];
         var old_date = "";
         var set_lgth = parseInt(e_data.length) / 4;

         var set_number;
         var metric_a_id, current_a_id;
         var metric_b_id, current_b_id;
         var metric_c_id, current_c_id;
         var metric_a, metric_b, metric_c;

         if(exerc_id === ExerciseFreeFormId) {

              var notes  = e_data[0].notes;

              exer_arr.push(<div key = {uniqueId()} dangerouslySetInnerHTML={createHTMLMarkup(notes)} >
                            { /*}<span style={{color:"#666", fontWeight:"bold", paddingRight: 10, textAlign: "left"}}>Free-Form Exercise </span>*/ }
                            </div>)
         } else {
                 for(var k = 0; k < set_lgth; k++) {
                      var measure_id  = e_data[k].measure_id;
                      var measure_val = e_data[k].measure_val;
                      var new_k = k+1;
                      var ctr1  = k+set_lgth;
                      var ctr2  = k+(set_lgth*2);
                      var ctr3  = k+(set_lgth*3);

                      if(k < set_lgth)
                          set_number = new_k;

                      if(ctr1 < set_lgth * 2) {
                          metric_a_id  = e_data[ctr1].measure_id;
                          current_a_id = getMeasureTitle(metric_a_id);
                          metric_a     = e_data[ctr1].measure_val;
                      }
                      if(ctr2 < set_lgth * 3) {
                          metric_b_id  = e_data[ctr2].measure_id;
                          current_b_id = getMeasureTitle(metric_b_id);
                          metric_b     = e_data[ctr2].measure_val;
                      }

                      if(ctr3 < set_lgth * 4) {
                          metric_c_id = e_data[ctr3].measure_id;
                          current_c_id = getMeasureTitle(metric_c_id);
                          metric_c    = e_data[ctr3].measure_val;
                      }

                      /*if(metric_a_id === 2 && metric_b_id === 12)  current_a_id = "LBs";
                      if(metric_b_id === 12) current_b_id = "Reps";*/
                      //if(current_a_id === "Pounds (Lbs)") current_a_id = "LBs";
                      //if(current_b_id === "Repetitions") current_b_id = "Reps";
                      var rest = <div style={{color:"#666", paddingLeft: 65}}>{current_c_id}: {metric_c} secs</div>
                      if(metric_c == "00:00") rest = "";

                      exer_arr.push(<div key = {uniqueId()}
                                          className = "">
                                          <span style={{color:"#666", fontWeight:"bold", paddingRight: 10, textAlign: "left"}}>Set { set_number }. </span>
                                          { parseInt(metric_a).toFixed(0) } {current_a_id} x { parseInt(metric_b).toFixed(0) } {current_b_id}
                                          {rest}
                                    </div>)
                 } // end for
         }

         return exer_arr;
    }

    async getExeriseSetsReps (block_id, block_name, exerc_name, exerc_id) {
        var client_id = this.props.clientId;
        var results   = await invokeClientSingleExerciseSetsReps(client_id, block_id, exerc_id);
        var sets_reps = this.parseExerciseDetailData(results.data, exerc_id);

        this.setState({
            index: 1,
            direction: "next",
            setsReps: sets_reps,
            blockName: block_name,
            exercName: exerc_name,
            exercId: exerc_id
        })
    }

    parseDayData(day_data) {
        var day_txt  = "";
        var day_arr = [];
        var block_ctr = 1;

        for(var key in day_data) {
            var block_id      = day_data[key].block_id;
            var block_name    = day_data[key].block_name;
            var exercise_lgth = day_data[key].exercise_lgth;
            var exercise      = day_data[key].exercise;

            // Ensure block name number integrity; ie Block 1, 2, 3 //
            if(block_name != null) {
                const splitStr = block_name.split(" ")
                var is_block_text = splitStr[0];
                var is_block_int  = parseInt(splitStr[1]);

                // If block name is "Block 1" or "Block 3" and they are out of order (ie Block 3, Block, 2, Block 1),
                // reorder them into consistent "Block 1, 2, 3" names
                if(is_block_text == "Block" && Number.isInteger(is_block_int))
                    block_name = "Block " + block_ctr++;
            } else {
                block_name = "Block " + block_ctr++;
            }

            if(key > 0) day_arr.push(<br key={uniqueId()}/>);

            day_arr.push(<div key={uniqueId()} style={{position: "relative", left:-5, fontSize: 18}}><strong>{block_name}</strong></div>)

            //day_arr.push(<ul>)

            for(var i=0; i < exercise_lgth; i++){
                var exerc_name = exercise[i].name;
                var exerc_id   = exercise[i].id;

                day_arr.push(<li key={uniqueId()}
                                 style={{position: "relative", left:0, cursor:"pointer", color: Colors.default_blue}}
                                 onClick={this.getExeriseSetsReps.bind(this, block_id, block_name, exerc_name, exerc_id)} data-id="1">
                                {exerc_name}
                             </li>);
            }

            //day_arr.push(</ul>)
        }

        return day_arr;
    }

     handleTabSelect = async (index) => {
         var weeks   = this.state.weekUids;
         var week_id = weeks[index-1];

         this.handleChangeWeeks(week_id);
     }

     handleChangeWeeks = (week_id) => {
         var program_id = this.state.programId
         var day_id     = 0; // reset day
         active_tab     = true; // reset back to first tab

         this.setState({
             error_msg: "Loading week data ...",
             currWeekId: week_id,
             currDayId: 0,
             index: 0,
             direction: "prev"
         }, function(){
             this.setModalProgramOverview(program_id, week_id, day_id);
         })
     }

    handleChangeDays = (day_id, day_num) => {

        var program_id = this.state.programId
        var week_id    = this.state.currWeekId;

        this.setState({
            error_msg: "Loading day data ...",
            week_id: week_id,
            currDayId: day_id,
            activeDayButton: day_id,
            index: 0,
            direction: "prev"
        }, function(){
            this.setModalProgramOverview(program_id, week_id, day_id);
        })
    }

    handleCarouselBack = () => {
        this.setState({
          index: 0,
          direction: "prev"
        });
    }

    handleSelect =(selectedIndex, e) => {
        this.setState({
          index: selectedIndex,
          direction: e.direction
        });
    }

    render() {

        const { index, direction } = this.state;

        var message_body  = this.props.messageBody;
        var message_title = this.props.messageTitle;
        var button_color  = "#408fd2";
        var body_text     = "Loading data...";

        var buttons = <span>
                            <Button className="modalBasicsBtnOk" onClick={() => this.handleCloseWin("ok")}>Close</Button>
                      </span>
        var weeks_length = this.state.weeksLength;
        var day_data     = this.state.dayData;

        //var week_uid     = this.state.weekUid;
        //var week_number  = this.state.weekNuumber;
        var week_tabs    = [];

        var week_numbers = this.state.weekNumbers;
        var week_uids    = this.state.weekUids;

        for(var w=0; w < weeks_length; w++) {
            var w_ctr = parseInt(w) + 1;
            var week_num = week_numbers[w];
            var week_id  = week_uids[w];

            week_tabs.push(<Tab key={uniqueId()}
                                eventKey  = {w_ctr}
                                title     = {"Week " + w_ctr}
                                className = "ModalProgOverviewWeekTabTitle"
                                onClick   = {this.handleChangeWeeks.bind(this,week_id)}>
                            </Tab>)
        }

        var days_length  = this.state.daysLength;
        var day_number = this.state.dayNumbers;
        var day_uid    = this.state.dayUids;

        if(days_length > 0) day_tabs = [];

        for(var d=0; d < days_length; d++) {
            var d_ctr    = parseInt(d) + 1;
            var day_num  = day_number[d];
            var day_id   = day_uid[d];
            var day_text = "Day " + day_num;

            if(this.state.activeDayButton == day_id || active_tab || this.state.currDayId == day_id)
                day_text = <span className="modalProgOverviewDayLinkActive"><b>{day_text}</b></span>

            day_tabs.push(<span key={uniqueId()}
                                  className="ProgramOverviewDayButtons"
                                  onClick={this.handleChangeDays.bind(this,day_id, day_num)}>
                                  {day_text}
                          </span>)

            active_tab = false; // reset default initial active tab
        }

        // clear loading text //
        if(weeks_length > 0) {
            body_text = this.parseDayData(day_data);
        }
        var body_div   = <span className="modalAlertBody" /*dangerouslySetInnerHTML={this.createMarkup(body_text)}*/>
                            {body_text}
                         </span>

        var detail_div = <div>
                                <span className="ModalProgOverviewExercSetsRepsBody">
                                      <div><b>{this.state.blockName}</b></div>
                                      <div>{this.state.exercName}</div>
                                      <br/>
                                      { this.state.setsReps }
                                </span>
                                <span className="ModalProgOverviewExercSetsRepsBackBtn"
                                      onClick={this.handleCarouselBack}>Back</span>
                         </div>

        var error_msg = this.state.error_msg;

        if(error_msg != "")
            body_div = <div className="ModalProgrOverviewErrorText">{error_msg}</div>

        return (
            <div>
                  <Modal
                         show            = {this.state.showModalProgramOverview}
                         onHide          = {() => this.handleCloseWin("close")}
                         aria-labelledby = "contained-modal-title"
                         size            = "lg"
                         centered        = "true"
                         className       = "modalBasics"
                       >
                         <Modal.Header>
                             <Modal.Title id="contained-modal-title">
                                    <FontAwesomeIcon icon="info-circle" className="modalAlertIcon" />
                                    <span className="modalBasicsTitle">
                                        { message_title }
                                    </span>
                             </Modal.Title>
                         </Modal.Header>

                         <Modal.Body>
                             <h2>{this.state.programName}</h2>
                             <br/>
                             <span className="modalAlertBody" /*dangerouslySetInnerHTML={this.createMarkup(message_body)}*/ >
                                     <Tabs defaultActiveKey={1}
                                           id="uncontrolled-tab"
                                           className = "ModalProgOverviewWeekTabs"
                                           onSelect={(event) => this.handleTabSelect(event)} >
                                            { week_tabs }
                                     </Tabs>
                                     <br/>
                                    <ButtonGroup size="lg" className="mb-2">
                                    { day_tabs }
                                    </ButtonGroup>
                                     <br/> <br/>

                                    <Carousel
                                        className   = "carouselProgOverview"
                                        activeIndex = {index}
                                        direction   = {direction}
                                        onSelect    = {this.handleSelect}
                                        style       = {{display: "inline-block", height: "100%", width: "100%", backgroundColor: "#fff"}}
                                      >
                                            <Carousel.Item>
                                                    { body_div }
                                            </Carousel.Item>
                                            <Carousel.Item>
                                                    { detail_div }
                                            </Carousel.Item>
                                      </Carousel>
                             </span>
                         </Modal.Body>

                         <Modal.Footer>
                             {buttons}
                         </Modal.Footer>
                   </Modal>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/modal/ModalProgramOverview.js